/* eslint-disable react/jsx-props-no-spreading */
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useDeviceDetect } from 'hooks';
import { SettingsMenu, SettingsDetails } from 'components/modules/portal';

function Settings({ children }) {
  const { isTablet } = useDeviceDetect();
  const [isMobileTabSelected, setMobileTabSelected] = useState(false);

  const hasSettingsMenu = !isMobileTabSelected || !isTablet;
  const hasSettingsDetails = !isTablet || isMobileTabSelected;

  const toggleSettingsDetails = () => isTablet && setMobileTabSelected(!isMobileTabSelected);

  return (
    <>
      {hasSettingsMenu && <SettingsMenu onSelectTab={toggleSettingsDetails} />}
      {hasSettingsDetails && <SettingsDetails onClickBack={toggleSettingsDetails}>{children}</SettingsDetails>}
    </>
  );
}

Settings.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Settings;
